<template>
  <v-select
    v-model="taxpayer"
    placeholder="Nº identificación del Emisor o Razón Social"
    :options="taxpayers"
    label="fullname"
    @input="searchTaxpayers"
    :loading="loading"
    readonly
  >
    <template v-slot:no-options="{ search, loading }">
      <template v-if="taxpayers.length === 0">
        No se encontraron resultados <em>{{ search }}</em>.
      </template>
      <em v-if="loading" style="opacity: 0.5">Cargando...</em>
    </template>
    <template #spinner="{ loading }">
      <div
        v-if="loading"
        style="border-left-color: rgba(88, 151, 251, 0.71)"
        class="vs__spinner"
      >
      </div>
    </template>
    <template #selected-option="{ name }">
      <b>{{ name }}</b>
    </template>
    <template #option="{ name, rif }">
      <b>{{ name }}</b> - <span style="font-size:15px;">{{ rif }}</span>
    </template>
  </v-select>
</template>

<script>
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  export default {
    middleware: 'auth',
    components: {
      vSelect,
    },
    props: {
      states: {
        type: String,
        required: false,
        default: '',
      },
      payroll: {
        type: Boolean,
        required: false,
        default: false,
      },
      client_type: {
        type: String,
        required: false,
        default: '',
      },
    },
    watch: {
      states: {
        handler() {
          this.searchAllTaxpayers(this.states);
        },
        deep: true,
      },
      client_type(value) {
        if (value !== '') {
          this.taxpayer = null;
        }
      },
    },
    data: () => ({
      taxpayers: [],
      loading: true,
      taxpayer: null,
    }),
    mounted() {
      this.searchAllTaxpayers(this.states);
    },
    methods: {
      searchAllTaxpayers(states) {
        this.$store.dispatch('taxpayer/setTaxpayerRif', { value: null });
        this.$store.dispatch('taxpayer/setTaxpayerId', { value: null });
        this.taxpayer = null;
        this.loading = true;
        states = (states === '' || states === null) ? '0' : states;
        let apiurl = '';
        if (this.$router.currentRoute.path === '/documentos/lista_documentos_nomina') {
           apiurl = `/api/enterprises/taxpayers/payrollActive/${states}`;
        } else if (this.$router.currentRoute.path === '/reportes/reportes_nominas') {
          apiurl = `/api/enterprises/taxpayers/payrollActive/${states}`;
        } else if (this.payroll === true) {
          apiurl = `/api/enterprises/taxpayers/payrollActive/${states}`;
        } else {
          apiurl = `/api/enterprises/taxpayers/${states}`;
        }
       // const apiurl = `/api/enterprises/taxpayers/${states}`;
        window.axios.get(apiurl)
          .then((response) => {
            this.taxpayers = response.data;
            this.loading = false;
            if (this.taxpayers.length === 0) {
              this.taxpayers = [];
              this.searching = true;
            }
          });
      },
      searchTaxpayers(value) {
        if (value !== null) {
          this.$store.dispatch('taxpayer/setTaxpayerRif', { value: value.rif });
          this.$store.dispatch('taxpayer/setTaxpayerId', { value: value.id });
        } else {
          this.$store.dispatch('taxpayer/setTaxpayerRif', { value: null });
          this.$store.dispatch('taxpayer/setTaxpayerId', { value: null });
        }
      },
    },
  };
</script>
<style>
  .vs__dropdown-toggle{
    border: none;
    border-radius: 0px;
    border-bottom: solid 1px rgba(0,0,0,0.40);
  }
  .vs__search::placeholder{
    color: rgba(0,0,0,0.60);
  }
  .v-select.vs--single{
    margin-top: 15px;
    color: black !important;
  }
  .vs--single .vs__selected {
    color: black !important;
  }
</style>
